<wbo-edit-page #editPage [formGroup]="editPage.formGroup" [title]="model.data.name">
    <wbo-edit-page-footer-controls>
        <wbo-switch-edit-control class="advanced-switch"
                                 [label]="'wbo.common.button.advanced'"
                                 [(value)]="pageState.advanced">
        </wbo-switch-edit-control>
    </wbo-edit-page-footer-controls>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.membership-type.edit.formation.details', formControlNames: ['name']}">
        <wbo-membership-type-edit-details></wbo-membership-type-edit-details>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.membership-type.edit.formation.pricing', formControlNames: ['discountId', 'priceLevelId']}">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-price-level-single-select-edit-control
                            formControlName="priceLevelId"
                            [(ngModel)]="model.data.priceLevelId"></wbo-price-level-single-select-edit-control>
                        <wbo-discount-single-select-edit-control
                            formControlName="discountId"
                            [(ngModel)]="model.data.discountId"></wbo-discount-single-select-edit-control>
                        <fui-inline-information [title]="'wbo.common.info.information'"
                                                [message]="'wbo.membership-type.edit.message.priceLevelsAndDiscounts'"></fui-inline-information>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.membership-type.edit.formation.rewards', formControlNames: ['accrualRewardRate.rewardRate.value',
        'accrualRewardRate.rewardRate.type', 'redemptionRewardRate.rewardRate.value', 'redemptionRewardRate.rewardRate.type',
        'pointsExpiryDays']}">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-tandem-field formGroupName="accrualRewardRate">
                            <ng-container formGroupName="rewardRate">
                                <wbo-numeric-edit-control
                                    [readonly]="isAccrualRewardRateValueReadOnly"
                                    [overrideRequired]="!isAccrualRewardRateValueReadOnly"
                                    formControlName="value"
                                    [(ngModel)]="model.data.accrualRewardRate.rewardRate.value"></wbo-numeric-edit-control>
                            </ng-container>
                            <ng-container formGroupName="rewardRate">
                                <wbo-member-loyalty-accrual-type-single-select-edit-control
                                    formControlName="type"
                                    [(ngModel)]="model.data.accrualRewardRate.rewardRate.type"
                                    (valueChange)="accrualTypeChanged($event)"
                                    [allowClearSelectionOption]="false"></wbo-member-loyalty-accrual-type-single-select-edit-control>
                            </ng-container>
                        </fui-tandem-field>
                    </fui-column>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-checkbox-edit-control
                                formControlName="wholePointsOnlyOnAccrual"
                                [(ngModel)]="model.data.wholePointsOnlyOnAccrual"></wbo-checkbox-edit-control>
                            <wbo-checkbox-edit-control
                                *ngIf="model.data.wholePointsOnlyOnAccrual"
                                formControlName="roundOnSaleTotal"
                                [(ngModel)]="model.data.roundOnSaleTotal"></wbo-checkbox-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-tandem-field formGroupName="redemptionRewardRate">
                            <ng-container formGroupName="rewardRate">
                                <wbo-numeric-edit-control
                                    [readonly]="isRedemptionRewardRateValueReadOnly"
                                    [overrideRequired]="!isRedemptionRewardRateValueReadOnly"
                                    formControlName="value"
                                    [(ngModel)]="model.data.redemptionRewardRate.rewardRate.value"></wbo-numeric-edit-control>
                            </ng-container>
                            <ng-container formGroupName="rewardRate">
                                <wbo-member-loyalty-redemption-type-single-select-edit-control
                                    formControlName="type"
                                    [(ngModel)]="model.data.redemptionRewardRate.rewardRate.type"
                                    (valueChange)="redemptionTypeChanged($event)"
                                    [allowClearSelectionOption]="false"></wbo-member-loyalty-redemption-type-single-select-edit-control>
                            </ng-container>
                        </fui-tandem-field>
                    </fui-column>
                    <fui-column>
                        <wbo-numeric-edit-control
                            formControlName="pointsExpiryDays"
                            [notation]="'wbo.membership-type.edit.field.pointsExpiryDays.notation' | translate"
                            [(ngModel)]="model.data.pointsExpiryDays"></wbo-numeric-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-inline-information [title]="'wbo.common.info.information'" [message]="'wbo.membership-type.edit.message.rewards'"></fui-inline-information>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.membership-type.edit.formation.customMembershipGroup'}">
        <wbo-membership-type-edit-custom-objects></wbo-membership-type-edit-custom-objects>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.membership-type.edit.formation.description', formControlNames: ['description']}">
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <wbo-textarea-edit-control formControlName="description"
                                               [(ngModel)]="model.data.description"></wbo-textarea-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-row>
    </fui-formation-group-template>
</wbo-edit-page>
